var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"autodesk-callback"},[_c('b-icon',{attrs:{"pack":"fas","icon":"spinner","custom-class":"fa-spin","size":"is-large"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }